export const REQUIRED = 'Please enter a value';
export const EMAIL_FORMAT = 'This is not a valid email';
export const LOCATION = 'Please find a valid location';
export const PHONE = 'Please enter a valid phone number';
